import React from 'react';
import { Link } from 'react-router-dom';

const Projects = ({ projects, language, limit }) => {
  const isPl = language === 'pl';
  const list = isPl ? projects.list_pl : projects.list_en;
  const displayedProjects = limit ? list.slice(0, limit) : list;

  return (
    <section className="section max-w-7xl mx-auto" id="projects">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gradient">
          {isPl ? "Projekty" : "Projects"}
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto">
          {isPl ? projects.description_pl : projects.description_en}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {displayedProjects.map((project, index) => (
          <div key={index} className="project-card group">
            <div className="overflow-hidden h-48 relative">
              <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" />
              <img 
                src={project.image} 
                alt={project.title} 
                loading="lazy"
              />
            </div>
            <div className="project-content">
              <h3 className="text-xl font-bold mb-2 text-white group-hover:text-[#04c7e1] transition-colors">
                {project.title}
              </h3>
              <p className="text-gray-400 text-sm mb-4 flex-grow">
                {project.description}
              </p>
              <div className="mt-auto pt-4 border-t border-white/10">
                <a 
                  href={project.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block text-[#04c7e1] hover:text-[#04c7e1]/80 font-semibold tracking-wide text-sm uppercase"
                >
                   {isPl ? "Zobacz Projekt →" : "View Project →"}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {limit && (
        <div className="text-center mt-12">
          <Link 
            to="/projekty" 
            className="inline-block px-8 py-3 rounded-full bg-gradient-to-r from-[#04c7e1] to-[#f2852d] text-white font-semibold transition-all hover:scale-105 shadow-lg shadow-[#04c7e1]/30"
          >
            {isPl ? "Zobacz Wszystkie Projekty" : "View All Projects"}
          </Link>
        </div>
      )}
    </section>
  );
};

export default Projects;
